import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn, actionPrintColumn, numeralColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P233List({ dataTable, setActionMulti }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData) => setActionMulti({ data: rowData, status: "EDIT" });
    const actionBodyPrint = (rowData) => setActionMulti({ data: rowData, status: "PRINT" });
    const actionBodyHeader = (act) => setActionMulti({ status: act, data: null });

    const headerAddLabel = <span className="hidden-responsive">เพิ่มรายการ</span>;

    const header = (
        <div className="table-header">
            {/* <Button className="p-button-secondary p-button btn-hidden-responsive" icon="pi pi-arrow-left" label={headerBackLabel} onClick={() => actionBodyHeader("208")} /> */}
            <Button className="p-button p-button-success btn-hidden-responsive span-responsive " label={headerAddLabel} icon="pi pi-plus" onClick={() => actionBodyHeader("NEW")} />
        </div>
    );
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    header={header}
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="withdrawSeq" header="งวดที่" body={(e) => normalColumn(e, "withdrawSeq", "งวดที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="withdrawAmount" header="จำนวนเงินรวมที่ขอเบิกจ่ายเงินค่างาน" body={(e) => numeralColumn(e, "withdrawAmount", "จำนวนเงินรวมที่ขอเบิกจ่ายเงินค่างาน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="letterNo" header="หนังสือขอเบิกเงินจ่ายเลขที่" body={(e) => normalColumn(e, "letterNo", "หนังสือขอเบิกเงินจ่ายเลขที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="letterDate" header="วันที่" body={(e) => normalColumn(e, "letterDate", "วันที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="remark" header="หมายเหตุ" body={(e) => normalColumn(e, "remark", "หมายเหตุ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaScore" header="แก้ไข" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaScore" header="พิมพ์" body={(e) => actionPrintColumn(e, actionBodyPrint)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
